import { Container, Feedback, Link, Text } from '@foradevelopment/fora-ui';
import { FAGroupViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { useTypedTranslation } from '../../i18n/i18n';
import { links } from '../../router/links';

export const FOKExpirationFeedback = ({ expiringFoks }: { expiringFoks: FAGroupViewModel[] }) => {
  const { t } = useTypedTranslation();

  if (!expiringFoks.length) {
    return null;
  }

  return (
    <Container marginBottom={60} maxWidth={783}>
      <Feedback type="warning" iconAbove={expiringFoks.length > 1 ? true : false}>
        {expiringFoks.map((expiringFok, i) => (
          <Text key={i} size="small" marginTop={expiringFoks.length > 1 ? 5 : undefined} marginBottom={6}>
            {t('section.employerActions.markupExpiring', {
              fokCode: expiringFok.fokId,
              fokIsExpiring: expiringFok.validTo,
            })}
          </Text>
        ))}
        <Link to={links.markups} fontSize="small">
          {t('warningMessages.expiringFoksLink')}
        </Link>
      </Feedback>
    </Container>
  );
};
